export const FRANQUIA_PATH = "instituicao/Franquia";

export interface Franquia {
  id: number;
  razaoSocial: string;
  nomeFantasia: string;
  email: string;
  cnpj: string;
}

export interface FranquiaFiltro {
  codigo?: string;
  razaoSocial?: string;
  cnpj?: string;
}
